var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-dropdown',{class:{ notArrow: _vm.collapseArrow },attrs:{"right":_vm.positionRight},scopedSlots:_vm._u([{key:"button-content",fn:function(){return [_vm._t("header")]},proxy:true}],null,true)},[_vm._t("list")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }